import { render, staticRenderFns } from "./contribution-sliders.vue?vue&type=template&id=082b0bf1"
import script from "./contribution-sliders.vue?vue&type=script&lang=js"
export * from "./contribution-sliders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./contribution-sliders.vue?vue&type=custom&index=0&blockType=i18n&lang=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HLabel: require('/home/runner/work/frontpages/frontpages/component-library/src/components/atoms/forms/h-label.vue').default})
